"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.createRequest = createRequest;
exports.default = void 0;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

require("core-js/modules/es6.function.name");

var _getIterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/get-iterator"));

var _isArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

require("core-js/modules/es6.regexp.match");

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _merge = _interopRequireDefault(require("lodash/merge"));

var _constant = require("../_utils/constant");

var cache = _interopRequireWildcard(require("../cache"));

var _pagination = require("./pagination");

var _pathToRegexp = _interopRequireDefault(require("path-to-regexp"));

var _qs = _interopRequireDefault(require("qs"));

var _axios = _interopRequireDefault(require("axios"));

/*
 * @Author: lijianzhang
 * @Date: 2018-11-02 14:12:15
 * @Last Modified by: 天吾
 * @Last Modified time: 2019-05-01 23:05:21
 */
function createRequest(config) {
  var request = _axios.default.create((0, _assign.default)({}, {
    paramsSerializer: function paramsSerializer(params) {
      return _qs.default.stringify(params, {
        arrayFormat: 'repeat'
      });
    }
  }, config)); // 支持 /user/:id 格式


  request.interceptors.request.use(function (config) {
    var url = config.url || '';
    var params = config.params;
    var data = config.data || {};

    try {
      var domain = '';
      var urlMatch = url.match(/[a-zA-z]+:\/\/[^/]*/);

      if (urlMatch) {
        domain = urlMatch[0];
        url = url.slice(domain.length);
      }

      var match = _pathToRegexp.default.parse(url);

      url = _pathToRegexp.default.compile(url)((0, _assign.default)({}, params, data));

      for (var _iterator = match, _isArray = (0, _isArray2.default)(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator2.default)(_iterator);;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var item = _ref;

        if (!(item instanceof Object)) {
          continue;
        }

        if (item.name in params) {
          delete params[item.name];
        } else if (item.name in data) {
          delete data[item.name];
        } else if (params[item.name] === '') {
          delete params[item.name];
        }
      }

      url = domain + url;
      config.url = url;
      config.params = params;
      config.data = data;
    } catch (e) {
      console.error(e.message);
      throw e;
    }

    return config;
  }, function (error) {
    return error;
  });
  request.interceptors.response.use(function (res) {
    if (process.env.VUE_APP_MOCK === 'true') {
      res.data = res.data.data ? res.data.data : res.data;
    }

    if (res.headers['x-pagination']) {
      try {
        res.pagination = new _pagination.Pagination(JSON.parse(res.headers['x-pagination']));
      } catch (error) {
        throw new Error('无效的 pagination 数据');
      }
    }

    return res;
  }, function (err) {
    if (err.message === 'Network Error') {
      throw new Error('网络加载失败，请检查您的网络设置');
    }

    if (!err.response) {
      throw err;
    }

    if (STATUS_CODES[err.response.status]) {
      throw new Error(STATUS_CODES[err.response.status]);
    } else {
      throw new Error(err.response.data.message || err.response.data);
    }
  });

  function getRequestId(baseURL, url, params) {
    if (params === void 0) {
      params = {};
    }

    return baseURL + (url || '') + '?' + _qs.default.stringify((0, _assign.default)({}, params));
  }
  /** ********* 缓存&重复请求 ********************/


  var defalutAdopter = request.defaults.adapter;
  var requestCache = {};

  request.defaults.adapter = function (config) {
    if (config.method === 'get') {
      var key = getRequestId(config.baseURL || '', config.url, config.params);
      var cacheConfig = typeof config.cache === 'object' ? config.cache : {
        type: 'sessionCache'
      };
      var storageName = cacheConfig.type || 'sessionCache';

      if (requestCache[key]) {
        return requestCache[key];
      } else if (config.cache) {
        var data = cache[storageName].get(key);

        if (data) {
          // 如果缓存配置了重新校验， 获取缓存后，需要再请求次数据更新缓存
          if (cacheConfig.revalidate) {
            // 目前的config.url 是已经加上 baseURL 的地址 baseURL 需要设置为空，否者再次请求的时候 有会加上 baseURL
            config.baseURL = '';
            request.request((0, _assign.default)({}, config, {
              cache: false
            })).then(function (res) {
              cache[storageName].set(key, (0, _assign.default)({}, {
                isCache: true
              }, res, {
                time: cacheConfig.time || '10m',
                version: cacheConfig.version
              }));
            }).catch(function () {//
            });
          }

          return _promise.default.resolve(data);
        }
      }

      var promise = defalutAdopter(config).then(function (res) {
        delete requestCache[key];

        if (config.cache) {
          cache[storageName].set(key, (0, _assign.default)({}, {
            isCache: true
          }, res), {
            time: cacheConfig.time || '10m',
            version: cacheConfig.version
          });
        }

        return res;
      }).catch(function (error) {
        delete requestCache[key];
        throw error;
      });
      requestCache[key] = promise;
      return promise;
    }

    return defalutAdopter(config);
  };

  return request;
}

var CancelToken = _axios.default.CancelToken;
var baseURL = _constant.REQUEST_URL; // const baseURL = 'http://www.dev.gaoding.com';

var request = createRequest({
  baseURL,
  withCredentials: true,
  timeout: 30 * 1000
});
var STATUS_CODES = {
  '401': 'User not authenticated'
};
request.interceptors.response.use(function (res) {
  if (res.headers['x-pagination']) {
    try {
      res.pagination = JSON.parse(res.headers['x-pagination']);
    } catch (error) {
      throw new Error('无效的 pagination 数据');
    }
  }

  return res;
}, function (err) {
  if (err.message === 'Network Error') {
    throw new Error('网络加载失败，请检查您的网络设置');
  }

  if (!err.response) {
    throw err;
  }

  if (STATUS_CODES[err.response.status]) {
    throw new Error(STATUS_CODES[err.response.status]);
  } else {
    throw new Error(err.response.data.message || err.response.data);
  }
});
var post = request.post.bind(request);

request.post = function (url, data, config) {
  if (data === void 0) {
    data = {};
  }

  if (config === void 0) {
    config = {};
  }

  var cancel;
  var cancelToken = new CancelToken(function executor(c) {
    // An executor function receives a cancel function as a parameter
    cancel = c;
  });
  var promise = post(url, data, (0, _merge.default)(config, {
    cancelToken
  }));
  promise.cancel = cancel;
  return promise;
};

request.setBaseURL = function (url) {
  request.defaults.baseURL = url;
};

var _default = request;
/** ********* 缓存&重复请求 END ********************/

exports.default = _default;